import { RedocStandalone } from "redoc";
import React from "react";


export const Tutorial = ()=>  {

  return <div className={'markdown redoc-wp'}>
    <RedocStandalone
      definitionUrl={`/spec/tutorial.yaml`}
      router="history"
      options={{
        scrollYOffset: 65,
        routingBasePath: `/tutorial`,
        layout: 'stacked',
        showExtensions: false,
        hideDownloadButtons: true,
        jsonSamplesExpandLevel: 0,
        schemasExpansionLevel: 0,
      }}
    />
  </div>
}